var _circle, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolana40(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3979 24.7382C12.5365 24.5996 12.7271 24.5188 12.9292 24.5188H31.2584C31.5933 24.5188 31.7608 24.923 31.524 25.1598L27.9032 28.7806C27.7646 28.9192 27.574 29 27.3719 29H9.04277C8.70783 29 8.54036 28.5958 8.77713 28.359L12.3979 24.7382Z",
    fill: "url(#paint0_linear_449_291)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.399 11.2194C12.5434 11.0808 12.734 11 12.9303 11H31.2595C31.5944 11 31.7619 11.4042 31.5251 11.641L27.9043 15.2618C27.7657 15.4004 27.5751 15.4812 27.373 15.4812H9.04387C8.70893 15.4812 8.54146 15.077 8.77823 14.8402L12.399 11.2194Z",
    fill: "url(#paint1_linear_449_291)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9032 17.9355C27.7646 17.7969 27.574 17.7161 27.3719 17.7161H9.04277C8.70783 17.7161 8.54036 18.1203 8.77713 18.3571L12.3979 21.9779C12.5365 22.1164 12.7271 22.1973 12.9292 22.1973H31.2584C31.5933 22.1973 31.7608 21.7931 31.524 21.5563L27.9032 17.9355Z",
    fill: "url(#paint2_linear_449_291)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_291",
    x1: -32.7608,
    y1: 7.59961,
    x2: -33.2485,
    y2: 32.1393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_449_291",
    x1: -38.3064,
    y1: 4.70375,
    x2: -38.7941,
    y2: 29.2435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_449_291",
    x1: -35.5519,
    y1: 6.14243,
    x2: -36.0395,
    y2: 30.6822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana40);
export default __webpack_public_path__ + "static/media/Solana_40.e57564b702ec8fe1ced474950bb9ad06.svg";
export { ForwardRef as ReactComponent };